import { cx } from 'linaria';
import React from 'react';
import './paddingbox.stylesheet_zxmwmj.css';

/* PaddingBox All around */
const paddingBoxAllAround = "p6rf3yt";

/* PaddingBox Top */
const paddingBoxTop = "psae6gu";

/* PaddingBox Bottom */
const paddingBoxBottom = "pe0f1tl";

/* PaddingBox Left */
const paddingBoxLeft = "p1les2qz";

/* PaddingBox Right */
const paddingBoxRight = "p1nf07j6";

/* PaddingBox Horizontal */
const paddingBoxHorizontal = "p1st7zcw";

/* PaddingBox Vertical */
const paddingBoxVertical = "p149922r";
const classNames = {
  paddingBoxAllAround,
  paddingBoxHorizontal,
  paddingBoxVertical,
  paddingBoxTop,
  paddingBoxBottom,
  paddingBoxLeft,
  paddingBoxRight
};

let Side;
(function (Side) {
  Side["A"] = "paddingBoxAllAround";
  Side["X"] = "paddingBoxHorizontal";
  Side["Y"] = "paddingBoxVertical";
  Side["T"] = "paddingBoxTop";
  Side["B"] = "paddingBoxBottom";
  Side["L"] = "paddingBoxLeft";
  Side["R"] = "paddingBoxRight";
})(Side || (Side = {}));
const PurePaddingBox = _ref => {
  let {
    side = Side.A,
    children,
    component = 'div',
    className
  } = _ref;
  const paddingBoxClass = side;
  return /*#__PURE__*/React.createElement(component, {
    className: cx(classNames[paddingBoxClass], className)
  }, children);
};
PurePaddingBox.displayName = 'PaddingBox';
var PurePaddingBox$1 = PurePaddingBox;

export { Side, PurePaddingBox$1 as default };
